import {api} from '../../../system/api';

export default {
    createShippingPartner: (params) => api.post('shipping-partners', {...params})
};
